import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardMedia, Grid, Button, Typography } from '@mui/material';
import classNames from 'classnames';
import styles from './ViewYourMobileCredentialsBanner.module.scss';
import { UserContext } from 'components/UserGuard';
import { useWindowSize } from 'util/Window';
import { defaultGridItemProps } from 'util/Layout';
import { Completions } from 'store/types/Completions';
import { trackFSEvent } from 'util/fullstory';
import EastIcon from '@mui/icons-material/East';
import Modal from 'components/shared/Modal';
import Appstore from 'assets/images/nccer/BuilderFax/builderfaxappstore.png';
import Playstore from 'assets/images/nccer/BuilderFax/builderfaxappgoogleplay.png';

function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent;
    //on ios devices send to app store, all else play store
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return "https://apps.apple.com/us/app/builderfax-by-lumber/id6754037484";
    }
    return "https://play.google.com/store/apps/details?id=com.lumberfi.builderfax";
}

export function ViewYourMobileCredentialsBanner(props: {completions: Completions}) {
  const { isMobile } = useWindowSize();
  const user = useContext(UserContext);
  const [display, setDisplay] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const hasCompletionsAndOptedIn = useCallback(() => {
    return user.digitalWalletCardOptIn && props.completions != undefined && props.completions.Completions.length > 1
  }, [props.completions, user])

  const openInBuilderfax = useCallback(() => {
    if(isMobile){
      trackFSEvent('builderfax_mobile_banner_app_store_click');
      window.open(getMobileOperatingSystem(), '_blank', 'noopener,noreferrer')
    }
    else {
      trackFSEvent('builderfax_mobile_banner_qr_code_click');
      setOpen(true)
    }
  }, [isMobile])

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setLoading(true);
    setDisplay(hasCompletionsAndOptedIn());
    setLoading(false);
  }, [hasCompletionsAndOptedIn]);
  return (
    <Box sx={{backgroundColor: "white", padding: "16px"}}>
        { display && (<Grid {...defaultGridItemProps} >
          <Card className={isMobile? classNames(styles.cardMobile): classNames(styles.card)} style={{padding: 0!}} sx={{overflow: 'hidden', height: isMobile? '161px' : '152px',}}>
            <CardActionArea onClick={openInBuilderfax}>
             <Box sx={{ position: 'relative', height: isMobile? '161px' : '152px',}}>
              <CardMedia
                  component="img"
                  image={isMobile? '/images/nccer/images/BuilderFaxAccessCredentialsMobile.png' : '/images/nccer/images/BuilderFaxAccessCredentials.png'}
                  alt="Access Your BuilderFax Credentials"
                  sx={{ display: "block", borderRadius: "5px", overflow: "hidden" }}
                />
                <Box
                width={isMobile? '70%' :'35%'}
                  sx={{
                    position: 'absolute',
                    top: 16,
                    left: 10,
                    color: 'white',
                    padding: '10px',
                  }}
                >
                  <Typography variant="h5">Your Credentials, Wherever you go</Typography>
                  <Typography variant="body2" sx={{ marginTop: '4px', color: 'white' }}>Take your NCCER credentials with you on mobile.</Typography>
                  <Button 
                    
                    variant={'contained'}
                    className={styles.printCredentialBtn} 
                    sx={{
                      backgroundColor: 'white',
                      color: '#3F5E9D' ,
                      marginTop: "16px"
                    }}>
                    Open App <EastIcon/>
                  </Button>
                </Box>
              </Box>
              </CardActionArea>
          </Card>
        </Grid>)}
        <Modal
          loading={loading}
          open={open}
          title={"View Your Credentials on Mobile"}
          subTitleText={'To view and manage your digital credentials on mobile, scan the QR code below or download the BuilderFax app to your phone.'}
          onClose={handleClose}
          actions={
            <Button sx={{width:"100%"}} color="secondary" variant="outlined" onClick={handleClose}>
              Close
            </Button>
          }
        >
          <Box sx={{display: "flex",  textAlign: "center", alignItems: "center"}}>
            <Box sx={{width: "50%",}}>
              <CardMedia
                    component="img"
                    sx={{width: "100%"}}
                    image={Appstore}/>
              <Typography variant='subtitle1'>
                Scan to Download on the App Store
              </Typography>
            </Box>
            <Box sx={{width: "50%"}}>
              <CardMedia
                    component="img"
                    sx={{width: "100%"}}
                    image={Playstore}/>
              <Typography variant='subtitle1'>
                Scan to Download on Google Play
              </Typography>
            </Box>
          </Box>
        </Modal>
      </Box>
  );
}

export default ViewYourMobileCredentialsBanner;
